<template>
<span id="speed" class="speed-text">
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{speed}}</span>
        </template>
        <span>Your Average Internet Speed</span>
    </v-tooltip>
    <span v-if="network">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                    <v-avatar color="white" size="57">
                        <v-icon color="red" size="47">mdi-wifi-off</v-icon>
                    </v-avatar>
                </span>
            </template>
            <span>{{network}}</span>
        </v-tooltip>
    </span>
    <!-- <iframe style="border: none;" src="https://cards.producthunt.com/cards/posts/146318?v=1" width="500" height="405" frameborder="0" scrolling="no" allowfullscreen></iframe> -->
</span>
</template>

<script>
// import JQuery from 'jquery'
// window.$ = JQuery;
// import "@/assets/js/jquery.speedtest.min.js";
export default {
    data: () => ({
        speed: '',
        network: '',
        tim: null,
    }),
    beforeDestroy() {
        clearInterval(this.tim);
    },
    mounted() {
        this.tim = setInterval(() => {
            this.getSpeed();
        }, 500);
    },
    updated() {

    },
    methods: {
        test() {
            navigator.connection.addEventListener('change', logNetworkInfo);

            function logNetworkInfo() {
                console.log('     downlink: ' + navigator.connection.downlink + 'Mb/s');
            }
            logNetworkInfo()
        },
        getSpeed() {
            if (navigator.onLine) {
                var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                //console.log(connection)
                if (connection != undefined) {
                    if (connection.downlink >= 10)
                        this.speed = connection.downlink + "+ Mbps",
                        //this.speeds = "Your Avg Internet Speed : " + connection.downlink + "+ Mbps",
                        this.network = ''
                    else
                        this.speed = connection.downlink + " Mbps",
                        //this.speed = "Your Avg Internet Speed : " + connection.downlink + "+ Mbps",
                        this.network = ''
                } else
                    this.speed = ''
            } else {
                this.network = 'Make sure your computer has an Active Internet Connection.'
                this.speed = ''
            }
        }
    },
}
</script>

<style scoped>
.speed-text {
    color: white;
    font-weight: bold;
}
</style>
